import { useIsHydrating } from '@muse-web/router'
import { AsyncLinkAudacityIntentContainer } from '@features/audacity'
import { CommentQueryKey } from '@features/comment'
import { useQueryClient } from '@tanstack/react-query'

import { AudioContentLayout } from './components/audio-content-layout/AudioContentLayout'
import { AsyncAudioClaimContainer } from './containers/AsyncAudioClaimContainer'
import { AudioAdditionalInfoContainer } from './containers/AudioAdditionalInfoContainer'
import { AudioHeroContainer } from './containers/AudioHeroContainer'
import { useAudioScreenAudio } from './store/useAudioScreenAudio'
import { useAudioScreenComments } from './store/useAudioScreenComments'
import { useAudioScreenLoaderData } from './store/useAudioScreenLoaderData'

export const Screen = () => {
    const { isClaim = false } = useAudioScreenLoaderData()
    const audio = useAudioScreenAudio()
    const comments = useAudioScreenComments()
    const queryClient = useQueryClient()

    // Seeded here, not in the panel: the hero reads the same query for its waveform markers, and it
    // renders first — passing `initialData` further down would leave the seed to mount order.
    if (comments && queryClient.getQueryData(CommentQueryKey.comments(audio.id)) === undefined) {
        queryClient.setQueryData(CommentQueryKey.comments(audio.id), comments)
    }

    const isHydrating = useIsHydrating()

    return (
        <>
            {!isHydrating && isClaim ? (
                <AsyncAudioClaimContainer audioId={audio.id} />
            ) : (
                <AsyncLinkAudacityIntentContainer />
            )}
            <AudioHeroContainer audio={audio} />
            <AudioContentLayout>
                <AudioAdditionalInfoContainer audio={audio} />
            </AudioContentLayout>
        </>
    )
}
